module.exports = __webpack_public_path__ + "img/1494479110.8f41a6b5.jpg";